import { Pipe, PipeTransform } from "@angular/core";
import { msToTime } from "@utils";

@Pipe({
  name: "msToTime",
  standalone: true
})
export class MsToTimePipe implements PipeTransform {
  transform(value: number, format?: "singlePadMinutes"): string {
    return msToTime(value, format);
  }
}
